import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // get this.el height
        this.height = this.el.offsetHeight;
        this.page = document.querySelector('.o-page');

        // update value on window resize
        this.resize();

        // add resize event listener
        this.addResizeListener();
    }

    resize() {
        // get this.el height
        this.height = this.el.offsetHeight;
        // add margin-bottom to .o-page
        this.addMargin();
    }

    addResizeListener() {
        window.addEventListener('resize', this.resize.bind(this));
    }

    addMargin() {
        // add margin-bottom to .o-page
        this.page.style.marginBottom = `${this.height}px`;
        this.page.style.paddingBottom = `1px`;
        this.page.style.paddingTop = `1px`;
    }
}
